import React from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles/styles';
import ProductGroupTranslationsForm from './ProductGroupTranslationsForm';
import {
  SetProductGroupTranslation,
  UpdateProductGroupTranslation,
} from '../../redux/actions/productGroupTranslation';
import { snackbarShowMessage } from '../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';

const ProductGroupTranslationModal = ({
  OpenProductGroupTranslations,
  handleClose,
  GroupSelected,
}) => {
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const classes = styles();
  const dispatch: any = useDispatch();
  const SaveTranslations = values => {
    const newValues = Object.keys(values).map(key => ({
      languageId: ~~key,
      value: values[key] === '' ? null : values[key],
    }));
    UpdateProductGroupTranslation(
      GroupSelected,
      selectedBrand,
      newValues,
    )(dispatch).then(result => {
      dispatch(
        snackbarShowMessage(
          `productGroups.translations.messages.updateSuccess`,
        ),
      );
      dispatch(SetProductGroupTranslation([]));
      handleClose();
    });
  };

  const { t } = useTranslation();

  return (
    <Dialog
      maxWidth="lg"
      open={OpenProductGroupTranslations}
      onClose={handleClose}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      aria-labelledby="max-width-dialog-title"
    >
      <DialogContent style={{ minHeight: '80vh' }}>
        <DialogTitle
          id="alert-dialog-title"
          className={classes.containerDialogTitle}
        >
          <div className={classes.divItems}>
            <Typography variant="h6">
              {t('productGroups.productGroupTranslations')}
            </Typography>
            <IconButton
              style={{ position: 'relative', marginLeft: '56px', padding: '0' }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <ProductGroupTranslationsForm
          SaveTranslations={SaveTranslations}
          CloseModal={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ProductGroupTranslationModal;
